import { Form } from "react-bootstrap";

const ColorInput = ({
  id,
  label,
  name,
  value,
  onChange,
  className = "",
  ...rest
}) => {
  return (
    <Form.Group className={className}>
      {label && <Form.Label htmlFor={id}>{label}</Form.Label>}
      <div className="color-boxs">
        <Form.Control
          id={id}
          type="color"
          value={value}
          name={name}
          onChange={onChange}
          className="my-2"
          {...rest}
        />
      </div>
    </Form.Group>
  );
};

export default ColorInput;
